import { cn } from "@/shared/lib/cn";
import { Diagram } from "iconsax-react";
import { Building2, ClipboardList, CreditCard, Settings, Users } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";

const navigation = [
  {
    name: "Applications",
    href: "/applications",
    icon: ClipboardList,
    iconType: "lucide" as const,
  },
  {
    name: "Configuration",
    href: "/configuration",
    icon: Settings,
    iconType: "lucide" as const,
  },
  { name: "Accounts", href: "/accounts", icon: Users, iconType: "lucide" as const },
  {
    name: "Transactions",
    href: "/transactions",
    icon: CreditCard,
    iconType: "lucide" as const,
  },
  { name: "Reports", href: "/reports", icon: Diagram, iconType: "iconsax" as const },
];

export function Sidebar() {
  const location = useLocation();

  return (
    <div className="w-64 border-r bg-gray-700 text-white">
      <div className="border-b-2 border-t border-border p-4">
        <div className="flex items-center gap-2">
          <Building2 className="h-6 w-6" />
          <div>
            <h1 className="text-sm font-semibold">Mock Lender Control Plane</h1>
          </div>
        </div>
      </div>

      <nav className="p-2">
        <ul className="space-y-1">
          {navigation.map((item) => {
            const isActive =
              item.href === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(item.href);

            return (
              <li key={item.name}>
                <NavLink
                  to={item.href}
                  className={cn(
                    "flex items-center gap-3 rounded px-1.5 py-1 text-sm transition-colors",
                    isActive
                      ? "bg-blue-700 font-medium"
                      : "hover:bg-gray-500 focus:bg-gray-500 focus-visible:bg-gray-500"
                  )}
                >
                  {item.iconType === "iconsax" ? (
                    <span className="flex h-3 w-3 items-center justify-center">
                      <item.icon size={16} variant="Linear" color="currentColor" />
                    </span>
                  ) : (
                    <item.icon className="h-3 w-3" />
                  )}
                  {item.name}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}
